import { IonModal } from '@ionic/react'
import React from 'react'
import { div } from 'sdk/fee/number-util'
import './index.scss'

interface IModalProps {
  icon?: string;
  message?: string;
  okText?: string;
  reject?: () => void;
  resolve?: () => void;
}

const ResultAlert: React.FC<IModalProps> = (props: IModalProps) => {
  const { icon, message, okText, reject, resolve } = props
  return (
    <IonModal
      cssClass='alert-modal '
      isOpen
      data-cypid='alertMobalClose'
      onDidDismiss={reject}
    >
      <div className='modal-content'>
        <i className='iconfont icon-close' data-cypid='alertMobalClose' onClick={reject}></i>
        <div className='main'>
          {icon &&
            <div className='main-icon'>
              <i className={`iconfont ${icon}`}></i>
            </div>}
          {message || ''}
        </div>
        <div className='modal-btn' data-cypid='alertMobalConfirm' onClick={resolve}>
          <div className='btn' data-cypid='alertMobalConfirm' onClick={resolve}>
            <span>{okText || i18n.t('cart.ikonw')}</span>
          </div>
        </div>
      </div>
    </IonModal>
  )
}

export default ResultAlert
